import { useMutation, useQuery, useQueryClient } from "react-query";
import { removeUserCookies, checkAuthTokenFn } from "../utils/cookieHelper";
import axios from "../utils/axios";
import toast from "react-hot-toast";
import { ERROR_MESSAGES, QUIZ_TYPE } from "../utils/constants";
import { useNavigate } from "react-router-dom";


const addQuizToClassroom = async ({ idClassroom, idQuiz, quizType }) => {
    checkAuthTokenFn();
    const resp = await axios.post(`/classroom/${idClassroom}/${quizType === QUIZ_TYPE.FASTQUIZ ? "fastquiz" : "quiz"}`, { idQuiz, quizType });
    return resp.data;
};

export const useAddQuizToClassroom = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutateAsync, isLoading } = useMutation(addQuizToClassroom, {
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries('/classrooms');
            toast.success("Quiz aggiunto con successo!");
        },
        onError: async (error) => {
            if (error?.code === 'ERR_NETWORK' || error?.code === "ERR_BAD_RESPONSE") {
                toast.error(ERROR_MESSAGES["ERR_NETWORK"]);
                return;
            }
            // if (error?.response?.data?.message === 'The maximum limit of quizzes for this classroom has been reached') {
            //     toast(ERROR_MESSAGES["ERR_REACHED_MAX_LIMIT_QUIZ_CLASSROOM"], {
            //         icon: '⚠️',
            //         duration: 5000,
            //     });
            //     navigate('/dashboard?tab=classroom');
            //     return;
            // }
            if (error?.response?.data?.message === 'Quiz is already in the classroom') {
                toast(ERROR_MESSAGES["ERR_EXIST_QUIZ"], {
                    icon: '⚠️',
                    duration: 5000,
                });
                return;
            }
            if (error?.response?.data?.message === 'Classroom not found') {
                toast(ERROR_MESSAGES["ERR_NOT_FOUND_CLASSROOM_FOR_ADD_QUIZ"], {
                    icon: '⚠️',
                    duration: 5000,
                });
                return;
            }
            if (error?.response?.data?.code === 401 || error?.response?.data?.code === 403) {
                removeUserCookies();
                navigate('/login');
                return;
            }
            toast.error(ERROR_MESSAGES[error.response.data.code], { duration: 7000 });
        },
    });
    return {
        addQuiz: mutateAsync,
        isAdditing: isLoading,
    };
};

const deleteQuizFromClassroom = async ({ idClassroom, idQuiz }) => {
    checkAuthTokenFn();
    const resp = await axios.delete(`/classroom/${idClassroom}/quiz/${idQuiz}`);
    return resp.data;
};

export const useDeleteQuizFromClassroom = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutateAsync, isLoading } = useMutation(deleteQuizFromClassroom, {
        retry: false,
        onSuccess: () => {
            queryClient.invalidateQueries('/classrooms');
            toast.success('Quiz rimosso con successo');
        },
        onError: async (error) => {
            if (error?.code === 'ERR_NETWORK' || error?.code === "ERR_BAD_RESPONSE") {
                toast.error(ERROR_MESSAGES["ERR_NETWORK"]);
                return;
            }
            if (error?.response?.data?.code === 401 || error?.response?.data?.code === 403) {
                removeUserCookies();
                navigate('/login');
                return;
            }
            if (error?.response?.data?.message === 'Classroom not found'
                ||
                error?.response?.data?.message === 'Quiz not found in the classroom') {
                toast(ERROR_MESSAGES["ERR_NOT_FOUND_CLASSROOM_OR_QUIZ"], {
                    icon: '⚠️',
                    duration: 5000,
                });
                return;
            }
            toast.error(ERROR_MESSAGES[error?.response?.data?.code], { duration: 7000 });
        },
    });

    return {
        deleteQuiz: mutateAsync,
        isDeletingQuiz: isLoading,
    };
};